import { createSlice } from '@reduxjs/toolkit';
import {
  EXPANDED_DESKTOP_NAVBAR_WIDTH,
  NAVBAR_WIDTH,
  DESKTOP_WIDTH_BREAKPOINT,
} from 'pages/PlaygroundV2Page/helpers';

const isDesktopScreen = window.innerWidth >= DESKTOP_WIDTH_BREAKPOINT;

interface AppState {
  isNavbarExpanded: boolean;
  navbarWidth: number;
}

const initialState: AppState = {
  isNavbarExpanded: isDesktopScreen,
  navbarWidth: NAVBAR_WIDTH,
};

const navbarSlice = createSlice({
  name: 'navbar',
  initialState,
  reducers: {
    toggleNavbar: (state: AppState) => {
      return {
        ...state,
        isNavbarExpanded: !state.isNavbarExpanded,
        navbarWidth: state.isNavbarExpanded ? NAVBAR_WIDTH : EXPANDED_DESKTOP_NAVBAR_WIDTH,
      };
    },
  },
});

export const { toggleNavbar } = navbarSlice.actions;
export default navbarSlice.reducer;
